// Export all storage interfaces and implementations
export * from './interfaces';
export * from './firebase-storage';
export * from './file-server';
export * from './storage-factory';

// Re-export the factory with a default instance
import { StorageProviderType } from './interfaces';
import { StorageFactory } from './storage-factory';

// Helper function to determine the default storage provider
function getDefaultStorageProvider(): StorageProviderType {
  return StorageProviderType.FIREBASE;
}

// Create and export a default storage factory instance
export const storageFactory = StorageFactory.getInstance({
  defaultProvider: getDefaultStorageProvider(),
});

